import { useState, useEffect } from "react";
import "./Packages.css";

const packageData = {
  premium: {
    title: "Luxego Premium Restoration",
    icon: "✨",
    prices: [
      { size: "Small", price: "£145" },
      { size: "Medium", price: "£165" },
      { size: "Large", price: "£185" },
      { size: "X-Large", price: "£205" }
    ],
    tagline: "Experience the ultimate in total care, inside out",
    includes: [
      "Interior deep detailing using drill brush, vacuum, steamer & extractor (seats, carpet, mats)",
      "Interior polished using satin/leather balm",
      "Contactless snow foam pre-wash",
      "2-bucket contact wash",
      "Seats shampoo and extract",
      "Door gaps & fuel caps cleaned",
      "Wheels & wheel arches cleaned",
      "Air freshener sprayed",
      "Glass cleaned with optical cleaner",
      "Plastics & tyres dressed",
      "3 Stage decontamination",
      "Hydrophobic paint protection",
      "Drying with premium cloth",
      "Engine bay detailed"
    ]
  },

  standard: {
    title: "Luxego Standard Detailing",
    icon: "⭐",
    prices: [
      { size: "Small", price: "£75" },
      { size: "Medium", price: "£95" },
      { size: "Large", price: "£115" },
      { size: "X-Large", price: "£135" }
    ],
    tagline: "Premium detailing, with an elevated finish",
    includes: [
      "Interior detailing",
      "Interior polished using satin/leather balm",
      "Shampoo mats",
      "Contactless snow foam pre-wash",
      "2-bucket contact wash",
      "Door gaps & fuel caps cleaned",
      "Wheels & wheel arches cleaned",
      "Air freshener sprayed",
      "Glass cleaned with optical cleaner",
      "Plastics & tyres dressed",
      "Hydrophobic paint protection",
      "Drying with premium cloth",
      "1 Stage decontamination"
    ]
  },

  exterior: {
    title: "Luxego Exterior Focused",
    icon: "💧",
    prices: [
      { size: "Small", price: "£65" },
      { size: "Medium", price: "£80" },
      { size: "Large", price: "£95" },
      { size: "X-Large", price: "£110" }
    ],
    tagline: "Enhanced shine with water repelling paint protection",
    includes: [
      "Contactless snow foam pre-wash",
      "2-bucket contact wash",
      "Wheels & wheel arches cleaned",
      "Door gaps & fuel caps cleaned",
      "3 Stage decontamination",
      "Hydrophobic paint protection",
      "Drying with premium cloth",
      "Plastics & tyres dressed"
    ]
  },

  interior: {
    title: "Luxego Interior Focused",
    icon: "🚗",
    prices: [
      { size: "Small", price: "£85" },
      { size: "Medium", price: "£105" },
      { size: "Large", price: "£125" },
      { size: "X-Large", price: "£145" }
    ],
    tagline: "Professional detailing for lasting freshness",
    includes: [
      "Interior deep detailing using drill brush, vacuum, steamer & extractor (seats, carpet, mats)",
      "Door gaps cleaned",
      "Interior polished using satin/leather balm",
      "Glass cleaned with optical cleaner",
      "Air freshener sprayed"
    ]
  },

  maintenance: {
    title: "Luxego Regular Maintenance",
    icon: "🛡",
    prices: [
      { size: "Small", price: "£45" },
      { size: "Medium", price: "£55" },
      { size: "Large", price: "£65" },
      { size: "X-Large", price: "£75" }
    ],
    tagline: "Essential care for regular upkeep",
    includes: [
      "Interior vacuum & wiping",
      "Contactless snow foam pre-wash",
      "2-bucket contact wash",
      "Wheels cleaned",
      "Drying with premium cloth",
      "Air freshener sprayed",
      "1 Stage decontamination",
      "Hydrophobic paint protection"
    ]
  }
};

const Packages = () => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (active) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [active]);

  return (
    <section className="packages-section">
      <div className="packages-grid">
        {Object.entries(packageData).map(([key, pkg]) => (
          <div
            key={key}
            className={`package-card ${key === "premium" ? "featured" : ""}`}
            onClick={() => setActive(key)}
          >
            {key === "premium" && (
              <span className="popular-badge">Most Popular</span>
            )}
            <div className="icon">{pkg.icon}</div>
            <h4>{pkg.title}</h4>
            <p className="price">
              {pkg.prices[0].price} – {pkg.prices[3].price}
            </p>
            <p className="tagline">"{pkg.tagline}"</p>
            <span className="link">Click to view full package details</span>
          </div>
        ))}
      </div>

      {active && (
        <div className="modal-overlay" onClick={() => setActive(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-btn"
              onClick={() => setActive(null)}
            >
              ×
            </button>

            <div className="modal-icon">
              {packageData[active].icon}
            </div>

            <h2>{packageData[active].title}</h2>
            <p className="modal-tagline">
              "{packageData[active].tagline}"
            </p>

            <div className="modal-prices">
              {packageData[active].prices.map((p) => (
                <div key={p.size}>
                  <span>{p.size}</span>
                  <strong>{p.price}</strong>
                </div>
              ))}
            </div>

            <h3>What's Included:</h3>

            <ul>
              {packageData[active].includes.map((item, i) => (
                <li key={i}>✔ {item}</li>
              ))}
            </ul>

            <p className="note">
              Prices may vary based on vehicle condition (£15 – £30)
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Packages;
